import { createTransform } from 'redux-persist'
import {
  CompanyPlanningRecordLettersState,
  initialState,
} from './companyPlanningRecordLettersSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  CompanyPlanningRecordLettersState,
  Omit<CompanyPlanningRecordLettersState, 'error'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: CompanyPlanningRecordLettersState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      status,
    }
  },
  {
    whitelist: ['companyPlanningRecordLetters'],
  },
)
